/* eslint-disable react-hooks/exhaustive-deps */
import { Form, Select, Switch } from "antd";
import { useForm } from "antd/lib/form/Form";
import Ripple from "components/Ripple";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import IEditProfile from "types/IEditProfile";
import AntDInputField from "./AntDInputField";
import UplaodProfilePicture from "./UplaodProfilePicture";
import UserProfileService from "services/UserProfileService";
import { updatePrfile } from "redux/userRedux";
import { BiLockAlt } from "react-icons/bi";
import { FaCrown } from "react-icons/fa";
import LoadingSpin from "components/Loading spins/LoadingSpin";
import { Helmet } from "react-helmet-async";

const layout = {
  wrapperCol: { span: 24 },
  style: { width: "100%" },
};

const onFinishFailed = (errorInfo: any) => {
  toast.error(errorInfo.errorFields[0].errors[0]);
};

function ProfileDetails({ profileDetails }: any) {
  const dispatch = useDispatch<any>();
  const loggedInUser = useSelector((state: any) => state?.user?.currentUser);
  const [form] = useForm<IEditProfile>();
  const [loading, setLoading] = useState<boolean>(false);
  const [profileImgeDetails, setProfileImageDetails] = useState("");
  const [loadingSpin, setLoadingSpin] = useState<boolean>(false);
  const [privateAccountChecked, setPrivateAccountChecked] = useState<boolean>(
    loggedInUser?.activity_privacy == 1 ? true : false
  );
  const [avatarPreview, setAvatarPreview] = useState<string>("");

  // live values for the preview panel
  const watchedName = Form.useWatch("name", form);
  const watchedBio = Form.useWatch("bio", form);

  // live avatar preview when a new image is picked
  useEffect(() => {
    if (!profileImgeDetails) return;
    if (typeof profileImgeDetails === "string") {
      setAvatarPreview(profileImgeDetails);
      return;
    }
    // File / Blob
    const url = URL.createObjectURL(profileImgeDetails as any);
    setAvatarPreview(url);
    return () => URL.revokeObjectURL(url);
  }, [profileImgeDetails]);

  const previewAvatar = avatarPreview || loggedInUser?.artwork_url;
  const previewName = watchedName ?? loggedInUser?.name;
  const previewBio =
    watchedBio !== undefined ? watchedBio : loggedInUser?.bio;

  const onChange = (checked: boolean) => {
    setPrivateAccountChecked(checked);
  };

  const onFinish = async (value: IEditProfile) => {
    setLoadingSpin(true);
    const finalObj: any = {
      ...value,
      artwork: profileImgeDetails,
      activity_privacy: privateAccountChecked ? 1 : 0,
    };
    const formDataObj = new FormData();

    for (const key in finalObj) {
      formDataObj.append(key, finalObj[key]);
    }

    await UserProfileService.editProfile(formDataObj)
      .then((response: any) => {
        setLoadingSpin(false);
        if (response.status === 200) {
          toast.success("Profile Updated");
          dispatch(updatePrfile(response.data));
        } else {
          toast.error("There is an issue when updating profile");
        }
      })
      .catch((e: any) => {
        setLoadingSpin(false);
        toast.error("An error occurred. Please try again.");
      });
  };

  useEffect(() => {
    setLoading(true);
    const initialValue: IEditProfile = {
      name: loggedInUser?.name,
      bio: loggedInUser?.bio ? loggedInUser?.bio : "",
      artwork: loggedInUser?.artwork_url ? loggedInUser?.artwork_url : "",
      soundcloud_url:
        loggedInUser?.soundcloud_url && loggedInUser?.soundcloud_url !== "null"
          ? loggedInUser?.soundcloud_url
          : "",
      instagram_url:
        loggedInUser?.instagram_url && loggedInUser?.instagram_url !== "null"
          ? loggedInUser?.instagram_url
          : "",
      youtube_url:
        loggedInUser?.youtube_url && loggedInUser?.youtube_url !== "null"
          ? loggedInUser?.youtube_url
          : "",
      facebook_url:
        loggedInUser?.facebook_url && loggedInUser?.facebook_url !== "null"
          ? loggedInUser?.facebook_url
          : "",
      twitter_url:
        loggedInUser?.twitter_url && loggedInUser?.twitter_url !== "null"
          ? loggedInUser?.twitter_url
          : "",
      website_url:
        loggedInUser?.website_url && loggedInUser?.website_url !== "null"
          ? loggedInUser?.website_url
          : "",
      gender: loggedInUser?.gender ? loggedInUser?.gender : "",
    };
    form.setFieldsValue(initialValue);
    setLoading(false);
  }, []);

  return (
    <>
      <Helmet>
        <title>Settings - AYOZAT</title>
        <meta
          name="description"
          content="Experience exclusive content and events on demand with our Pay-Per-View service."
        />
        <meta property="og:title" content="Settings - AYOZAT" />
        <meta
          property="og:description"
          content="Experience exclusive content and events on demand with our Pay-Per-View service."
        />
        <meta property="og:image" content="https://ayozat.co.uk/logo192.png" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Settings - AYOZAT" />
        <meta
          name="twitter:description"
          content="Experience exclusive content and events on demand with our Pay-Per-View service."
        />
        <meta name="twitter:image" content="https://ayozat.co.uk/logo192.png" />
        <meta name="twitter:site" content="AYOZAT Payperview" />
      </Helmet>

      <div className="mb-6 w-full px-4 max-sm:px-3">
        {!loading ? (
          <Form
            {...layout}
            form={form}
            onFinishFailed={onFinishFailed}
            onFinish={onFinish}
            autoComplete="on"
          >
            <div className="mt-5 grid grid-cols-1 gap-6 lg:grid-cols-3">
              {/* MAIN form (2/3) */}
              <div className="rounded-2xl border border-white/10 bg-white/[0.02] p-6 lg:col-span-2 max-sm:p-4">
                <h1 className="text-[25px] font-bold text-white max-sm:text-[22px]">
                  Edit Profile
                </h1>
                <p className="mb-4 mt-1 text-sm text-white/50">
                  Update your public profile and social links.
                </p>

                <UplaodProfilePicture
                  setProfileImageDetails={setProfileImageDetails}
                />

                {/* Private account toggle */}
                <div className="my-4 flex items-center justify-start gap-3 rounded-xl border border-white/10 bg-white/[0.03] px-4 py-3">
                  <BiLockAlt className="text-white/70" />
                  <p className="text-md flex-1 text-white">Private Account</p>
                  <Switch
                    defaultChecked={privateAccountChecked}
                    onChange={onChange}
                    style={{
                      backgroundColor: privateAccountChecked
                        ? "red"
                        : "#313131",
                      transitionDuration: "300ms",
                    }}
                  />
                </div>

                {/* Name + Gender */}
                <div className="flex w-full gap-6 max-sm:flex-col max-sm:gap-0">
                  <div className="grow">
                    <span className="block text-[15px] text-white">Name</span>
                    <AntDInputField
                      name="name"
                      rules={[
                        { required: true, message: "Please enter your name!" },
                      ]}
                    />
                  </div>

                  <div className="w-[220px] shrink-0 max-sm:w-full">
                    <span className="block text-[15px] text-white">Gender</span>
                    <Form.Item
                      required
                      name="gender"
                      className="!mb-8 !mt-3"
                      rules={[
                        { required: true, message: "Please select a gender." },
                      ]}
                    >
                      <Select
                        style={{ width: "100%" }}
                        className="ayozat-dark-select"
                        popupClassName="ayozat-dark-select-dropdown"
                        options={[
                          { value: "M", label: "Male" },
                          { value: "F", label: "Female" },
                          { value: "O", label: "Other" },
                          { value: "P", label: "Prefer not to say" },
                        ]}
                      />
                    </Form.Item>
                  </div>
                </div>

                <span className="block text-[15px] text-white">Bio</span>
                <AntDInputField name="bio" />

                {/* Social links */}
                <h2 className="mb-1 mt-4 text-[17px] font-semibold text-white">
                  Social Links
                </h2>
                <p className="mb-3 text-xs text-white/50">
                  Add your profiles so fans can find you everywhere.
                </p>
                <div className="grid grid-cols-2 gap-x-6 max-sm:grid-cols-1">
                  <div>
                    <span className="text-[15px] text-white">Soundcloud url</span>
                    <AntDInputField name="soundcloud_url" className="!mb-2" />
                  </div>
                  <div>
                    <span className="text-[15px] text-white">Instagram url</span>
                    <AntDInputField name="instagram_url" className="!mb-2" />
                  </div>
                  <div>
                    <span className="text-[15px] text-white">Youtube url</span>
                    <AntDInputField name="youtube_url" className="!mb-2" />
                  </div>
                  <div>
                    <span className="text-[15px] text-white">Facebook url</span>
                    <AntDInputField name="facebook_url" className="!mb-2" />
                  </div>
                  <div>
                    <span className="text-[15px] text-white">Twitter url</span>
                    <AntDInputField name="twitter_url" className="!mb-2" />
                  </div>
                  <div>
                    <span className="text-[15px] text-white">Website url</span>
                    <AntDInputField name="website_url" className="!mb-2" />
                  </div>
                </div>

                <Form.Item wrapperCol={{ offset: 0, span: 24 }}>
                  <button
                    className="button-red mt-8 min-w-[130px] rounded-full px-4 py-2 text-white transition-opacity hover:opacity-90 max-sm:w-full"
                    type="submit"
                  >
                    {loadingSpin ? (
                      <LoadingSpin fontSize={20} color={"white"} />
                    ) : (
                      `Save Changes`
                    )}
                  </button>
                </Form.Item>
              </div>

              {/* SIDE: preview + account (1/3) */}
              <div className="space-y-6 lg:col-span-1">
                {/* Profile preview */}
                <div className="rounded-2xl border border-white/10 bg-white/[0.02] p-6">
                  <p className="mb-4 text-xs font-semibold uppercase tracking-[0.15em] text-white/40">
                    Preview
                  </p>
                  <div className="flex flex-col items-center text-center">
                    <img
                      src={previewAvatar}
                      alt="profile"
                      className="h-24 w-24 rounded-full object-cover ring-2 ring-[var(--red,#F50537)]/50"
                    />
                    <div className="mt-3 flex items-center gap-2">
                      <p className="text-lg font-semibold text-white">
                        {previewName}
                      </p>
                      {loggedInUser?.is_subscribed && (
                        <FaCrown className="text-[14px] text-[var(--red,#F50537)]" />
                      )}
                    </div>
                    <p className="text-sm text-white/50">
                      @{loggedInUser?.username}
                    </p>
                    <p className="mt-3 text-sm leading-relaxed text-white/60">
                      {previewBio || "No bio yet."}
                    </p>
                  </div>
                </div>

                {/* Account info */}
                <div className="rounded-2xl border border-white/10 bg-white/[0.02] p-6">
                  <p className="mb-4 text-xs font-semibold uppercase tracking-[0.15em] text-white/40">
                    Account
                  </p>
                  <div className="space-y-3 text-sm">
                    <div className="flex items-center justify-between">
                      <span className="text-white/50">Visibility</span>
                      <span className="font-medium text-white">
                        {privateAccountChecked ? "Private" : "Public"}
                      </span>
                    </div>
                    <div className="flex items-center justify-between">
                      <span className="text-white/50">Membership</span>
                      <span className="font-medium text-white">
                        {loggedInUser?.is_subscribed ? "Plus" : "Free"}
                      </span>
                    </div>
                    {loggedInUser?.email && (
                      <div className="flex items-center justify-between gap-3">
                        <span className="text-white/50">Email</span>
                        <span className="truncate font-medium text-white">
                          {loggedInUser.email}
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </Form>
        ) : (
          <Ripple />
        )}
      </div>

      {/* dark theme for antd Select (gender) */}
      <style>{`
        .ayozat-dark-select .ant-select-selector {
          background-color: rgba(255, 255, 255, 0.05) !important;
          border: 1px solid rgba(255, 255, 255, 0.12) !important;
          color: #fff !important;
          height: 50px !important;
          border-radius: 8px !important;
          display: flex !important;
          align-items: center !important;
          box-shadow: none !important;
        }
        .ayozat-dark-select .ant-select-selection-item,
        .ayozat-dark-select .ant-select-selection-placeholder {
          color: #fff !important;
        }
        .ayozat-dark-select .ant-select-arrow {
          color: rgba(255, 255, 255, 0.5) !important;
        }
        .ayozat-dark-select:hover .ant-select-selector {
          border-color: rgba(255, 255, 255, 0.3) !important;
        }
        .ayozat-dark-select.ant-select-focused .ant-select-selector {
          border-color: var(--red, #f30543) !important;
          box-shadow: 0 0 0 2px rgba(243, 5, 67, 0.15) !important;
        }
        .ayozat-dark-select-dropdown {
          background-color: #1a1a1d !important;
        }
        .ayozat-dark-select-dropdown .ant-select-item {
          color: rgba(255, 255, 255, 0.8) !important;
        }
        .ayozat-dark-select-dropdown .ant-select-item-option-active,
        .ayozat-dark-select-dropdown .ant-select-item-option-selected {
          background-color: rgba(243, 5, 67, 0.15) !important;
          color: #fff !important;
        }
      `}</style>
    </>
  );
}

export default ProfileDetails;